import Vue from "vue";

const getDefaultState = () => {
	return {
		invitations: null,
	};
};

const Invitations = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		SET_INVITATIONS: async (state, invitations) => {
			state.invitations = invitations.filter(invitation => !invitation.dentied_at);
		},
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
	},
	actions: {
		fetchInvitations: ({ commit, rootState }, status = "pending") => {
			return Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/invitations`, {
					params: {
						status: [status],
					},
				})
				.then(response => {
					commit("SET_INVITATIONS", response.data);
				})
				.catch(err => console.log(err.response));
		},

		acceptInvitation: ({ rootState, dispatch }, invitationId) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/invitations/${invitationId}`, {
					status: "accepted",
				})
				.then(response => {
					dispatch("fetchInvitations");
				})
				.catch(err => console.log(err.response));
		},

		acceptInvitationViaToken: ({ dispatch }, payload) => {
			return Vue.prototype.$apiService.patch("accept/account", null, { params: { invitation_token: payload } });
		},

		denyInvitation: ({ rootState, dispatch }, invitationId) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/invitations/${invitationId}`, {
					status: "denied",
				})
				.then(response => {
					dispatch("fetchInvitations");
				})
				.catch(err => console.log(err.response));
		},
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
	},
	getters: {},
};

export default Invitations;
